import './App.css';
import PerfumeToGreatness from './components/PerfumeToGreatness';

function App() {
  return (
    <PerfumeToGreatness/>
  );
}

export default App;
